const CustomLinkInstallmentRow = props => {
  const { e, i, handlePaymentScheduleUpdate, handleDeleteInstallment } = props;
  const handleFieldChange = (index, fieldName, newValue) => {
    if (fieldName !== 'clp_due_date') {
      handlePaymentScheduleUpdate(index, 'clp_due_date', '');
    }
    handlePaymentScheduleUpdate(index, fieldName, newValue);
  };

  return (
    <tr key={`${i}_${e.id}`}>
      {/* <td>{i + 1}</td> */}
      <td>
        <input
          className="form-control"
          disabled={!(e.clp_payment_no === 0 || e.clp_payment_no === '0')}
          name={`e.${i}.clp_payment_installment`}
          value={e.clp_payment_installment}
          onChange={x => {
            handlePaymentScheduleUpdate(i, 'clp_payment_installment', x.target.value);
          }}
        />
      </td>
      {e.clp_date && (
        <td>
          <input
            className="form-control"
            disabled={!e.custom}
            name={`e.${i}.clp_due_date`}
            type="date"
            value={e.clp_date}
            onChange={x => {
              handlePaymentScheduleUpdate(i, 'clp_due_date', x.target.value);
            }}
          />
        </td>
      )}
      {!e.clp_date && e.custom && (
        <td>
          <input
            className="form-control"
            disabled={!e.custom}
            name={`e.${i}.clp_due_date`}
            type="date"
            value={e.clp_due_date || ''} // Empty if no due date is set
            onChange={x => handleFieldChange(i, 'clp_due_date', x.target.value)} // Change handler
          />
        </td>
      )}

      {/* If installment is not custom, show a placeholder input */}
      {!e.clp_date && !e.custom && (
        <td>
          <input
            className="form-control"
            disabled={!(e.clp_payment_no === 0 || e.clp_payment_no === '0')}
            name={`e.${i}.clp_due_date`}
            placeholder="From CLP Due Date"
            type={!(e.clp_payment_no === 0 || e.clp_payment_no === '0') ? 'text' : 'date'}
            value={e.clp_due_date || ''} // Empty if no due date is set
            onChange={x => handleFieldChange(i, 'clp_due_date', x.target.value)} // Change handler
          />
        </td>
      )}
      <td>
        {!e.lastRow && e.clp_payment_installment !== 'Other Charges (Separately)' && (
          <input
            // readOnly
            className="form-control"
            disabled={!(e.clp_payment_no === 0 || e.clp_payment_no === '0')}
            name={`e.${i}.clp_per`}
            type="number"
            value={e.clp_per}
            onChange={x => {
              handlePaymentScheduleUpdate(i, 'clp_per', x.target.value);
            }}
          />
        )}
      </td>
      <td>
        {!e.lastRow && e.clp_payment_installment !== 'Other Charges (Separately)' && (
          <input
            readOnly
            className="form-control"
            name={`e.${i}.clp_basic_amt`}
            type="number"
            value={e.clp_basic_amt !== 0 ? e.clp_basic_amt.toFixed(2) : e.clp_basic_amt.toFixed(2)}
          />
        )}
      </td>
      <td>
        <input
          readOnly
          className="form-control"
          name={`e.${i}.clp_otherchages_amt`}
          type="number"
          value={
            e.clp_otherchages_amt !== 0
              ? e.clp_otherchages_amt.toFixed(2)
              : e.clp_otherchages_amt.toFixed(2)
          }
        />
      </td>
      <td>
        <input
          readOnly
          className="form-control"
          name={`e.${i}.clp_gst`}
          type="number"
          value={e.clp_gst !== 0 ? e.clp_gst.toFixed(2) : e.clp_gst.toFixed(2)}
        />
      </td>
      <td>
        <input
          readOnly
          className="form-control"
          name={`e.${i}.clp_extrachages_amt`}
          type="number"
          value={
            e.clp_extrachages_amt !== 0
              ? e.clp_extrachages_amt.toFixed(2)
              : e.clp_extrachages_amt.toFixed(2)
          }
        />
      </td>
      <td>
        <input
          readOnly
          className="form-control"
          name={`e.${i}.clp_installment_amount`}
          type="number"
          value={
            e.clp_installment_amount !== 0
              ? e.clp_installment_amount.toFixed(2)
              : e.clp_installment_amount.toFixed(2)
          }
        />
      </td>
      <td>
        {!e.lastRow && e?.clp_payment_no === 0 ? (
          <button
            className="add-comp-btn m-0 acount-act-btn red-common"
            type="button"
            onClick={() => handleDeleteInstallment(i)}
          >
            <svg
              fill="none"
              height="10"
              viewBox="0 0 6 8"
              width="8"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M0.498698 6.91667C0.498698 7.375 0.873698 7.75 1.33203 7.75H4.66537C5.1237 7.75 5.4987 7.375 5.4987 6.91667V1.91667H0.498698V6.91667ZM5.91537 0.666667H4.45703L4.04036 0.25H1.95703L1.54036 0.666667H0.0820312V1.5H5.91537V0.666667Z"
                fill="#FF5D5D"
              ></path>
            </svg>
          </button>
        ) : undefined}
      </td>
    </tr>
  );
};

export default CustomLinkInstallmentRow;
